import { render } from "./CatalogCategories.vue?vue&type=template&id=4e5c9904&scoped=true"
import script from "./CatalogCategories.vue?vue&type=script&lang=js"
export * from "./CatalogCategories.vue?vue&type=script&lang=js"

import "./CatalogCategories.vue?vue&type=style&index=0&id=4e5c9904&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e5c9904"]])

export default __exports__